import axios from "axios";
import jwt_decode from "jwt-decode";
import Swal from "sweetalert2";
import CryptoJS from "crypto-js";
import cookie from "vue-cookie";
import Vue from 'vue'

export const state = {
  JWToken: cookie.get("ecampus"),
  Avatar: null,
};

export const getters = {
  isAuth(state) {
    if (state.JWToken) {
      return true;
    } else {
      return false;
    }
  },
  JWToken(state) {
    if (state.JWToken) {
      return CryptoJS.AES.decrypt(
        window.$cookies.get("ecampus"),
        process.env.VUE_APP_SHA_KEY
      ).toString(CryptoJS.enc.Utf8);
    }
  },
  UserRolles(){
      let token=CryptoJS.AES.decrypt(window.$cookies.get('ecampus'), process.env.VUE_APP_SHA_KEY).toString(CryptoJS.enc.Utf8)
      var roles = jwt_decode(token).roles
      if(roles){
       if(roles.constructor.name == "Array"){
        return jwt_decode(token).roles
       }else{
        var role = []
        role.push(jwt_decode(token).roles);
        return role
       } }else{
        return []
      }
  },
  UserNameSurName() {
    let token = CryptoJS.AES.decrypt(
      window.$cookies.get("ecampus"),
      process.env.VUE_APP_SHA_KEY
    ).toString(CryptoJS.enc.Utf8);
    let decodetoken = jwt_decode(token);
    return decodetoken.given_name + " " + decodetoken.family_name;
  },
  TokenEPosta() {
    let token = CryptoJS.AES.decrypt(
      window.$cookies.get("ecampus"),
      process.env.VUE_APP_SHA_KEY
    ).toString(CryptoJS.enc.Utf8);
    let decodetoken = jwt_decode(token);
    return decodetoken.email;
  },
  TokenUserId(){
    let token=CryptoJS.AES.decrypt(window.$cookies.get('ecampus'), process.env.VUE_APP_SHA_KEY).toString(CryptoJS.enc.Utf8)
    let decodetoken = jwt_decode(token)
    return decodetoken.uid
},
  Avatar(state) {
    return state.Avatar;
  },
  AvatarUrl() {
    let token = CryptoJS.AES.decrypt(
      window.$cookies.get("ecampus"),
      process.env.VUE_APP_SHA_KEY
    ).toString(CryptoJS.enc.Utf8);
    return jwt_decode(token).avatar;
  },
};

export const mutations = {
  SetJWToken(state, JWToken) {
    var decoded = jwt_decode(JWToken).exp;
    decoded = new Date(decoded * 1000);
    //decoded.setHours( decoded.getHours() + 3 )
    let tokensifreleme = CryptoJS.AES.encrypt(
      JWToken,
      process.env.VUE_APP_SHA_KEY
    ).toString();
    window.$cookies.set(
      "ecampus",
      tokensifreleme,
      decoded,
      null,
      Vue.prototype.$config.COOKIES_DOMAIN
    );
    state.JWToken = tokensifreleme;
  },
  SetAuth(state, Auth) {
    state.AuthInfo = Auth;
  },
  SetAvatar(state, Avatar) {
    state.Avatar = Avatar;
  },
  ClearJWToken(state) {
    window.$cookies.remove("ecampus",null,Vue.prototype.$config.COOKIES_DOMAIN);
    state.JWToken = null;
    state.AuthInfo = null;
  },
};

export const actions = {
  ActionsLoginSessionKey({ commit }, Data) {  
    return axios
      .post(Vue.prototype.$config.API_ACCOUNT_URL + "Account/authenticate", Data)
      .then((res) => { 
        console.log(res);
        if (res.data.Succeeded == true) {
          commit("SetJWToken", res.data.Data.JWToken);
          commit("SetAuth", res.data.Data);
          return true;
        } else {
          return false; 
        }
      })
      .catch((error) => error.response.data)
      .catch((error) => {
        console.log(JSON.parse(JSON.stringify(error.response.data.errors)));
      });
  },
  //Login
  StrActionsLogin({ commit }, token) {
    commit("SetJWToken", token);
    return true;
  },
  //Sayfa Yenilenince Token Tutmak İçin
  initAuth({ commit }) {
    let JWToken = window.$cookies.get("ecampus");
    if (JWToken != undefined) {
      commit("SetJWToken", JWToken);
    } else {
      return false;
    }
  },
  logOut({ commit }) { console.log("ada");
    commit("ClearJWToken");
    window.location = Vue.prototype.$config.LOGIN_URL;
  },

  HeaderAvatar({ commit, getters }) { 
    let Filter = "?fileName=" + getters.AvatarUrl + "&pathUrl=Avatars"; 
    return axios({
      url: "GenericFileUpDownload/DownloadFile" + Filter,
      method: "GET",
      responseType: "blob",
    })
      .then((res) => {
        
        let blob = new Blob([res.data]);
          let link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob); 
          commit("SetAvatar", link.href);
      })
      .catch((error) => error.response.data)
      .catch((error) => {
        console.log(JSON.parse(JSON.stringify(error.response.data.errors)));
      });
  },
  TokenRefreshZamanKontrol({ dispatch, getters }) {
    var decoded = jwt_decode(getters.JWToken);
    decoded = new Date(decoded.exp * 1000);
    let diffTime = Math.abs(new Date().valueOf() - decoded.valueOf());
    var kalanzaman = Math.floor(diffTime / 1000);
    if (kalanzaman < 90 && 0 < kalanzaman) {
      dispatch("ActionsRefreshToken");
    }
    
  },

  ActionsRefreshToken({ commit, dispatch, getters }) {
    let Data = { Token: getters.JWToken };
    axios
      .post(Vue.prototype.$config.API_ACCOUNT_URL + "Account/refresh-token", Data)
      .then((res) => {
        if (res.data.Succeeded == true) {
          commit("SetJWToken", res.data.Data.Token);
          dispatch("TokenZamaniHesaplama");
        }
      })
      .catch((error) => error.response.data)
      .catch((error) => {
        console.log(JSON.parse(JSON.stringify(error.response.data.errors)));
      });
  },

  TokenZamaniHesaplama({ dispatch, getters }) {
   // if(!getters.JWToken)dispatch("logOut");
    if(!getters.JWToken){
        var decoded = jwt_decode(getters.JWToken);
        decoded = new Date(decoded.exp * 1000);
        let diffTime = Math.abs(new Date().valueOf() - decoded.valueOf());
        var kalanzaman = Math.floor(diffTime / 1000);
        kalanzaman = (kalanzaman - 30) * 1000; 
        dispatch("CookiesZamanKontrol", kalanzaman);
    }
  },

  CookiesZamanKontrol({ dispatch, commit }, kalanzaman) {
    setTimeout(
      function() {
        var mevcuttoken =CryptoJS.AES.decrypt(
          cookie.get("ecampus"),
          process.env.VUE_APP_SHA_KEY
        ).toString(CryptoJS.enc.Utf8);

        var tokenkontrol = setInterval(
          function() { 
            let sifrecoz = CryptoJS.AES.decrypt(
              cookie.get("ecampus"),
              process.env.VUE_APP_SHA_KEY
            ).toString(CryptoJS.enc.Utf8); 
            if (sifrecoz != mevcuttoken) {
              Swal.close();
              clearInterval(timerInterval); 
              clearInterval(tokenkontrol);  
              commit("SetJWToken", sifrecoz);
              dispatch("TokenZamaniHesaplama"); 
            } 
          }.bind(this),
          100
        );

        let timerInterval;
        Swal.fire({
          title: "Oturum Süreniz Dolmak Üzere",
          html: "Son <b>30</b> saniye süreniz kaldı.",
          timer: 30000,
          timerProgressBar: true,
          confirmButtonText: "Devam",
          onBeforeOpen: () => {
            Swal.showLoading();
            timerInterval = setInterval(() => {
              Swal.getHtmlContainer().querySelector("b").textContent = (
                Swal.getTimerLeft() / 1000
              ).toFixed(0);
            }, 1000);
          },
          onClose: () => {
            clearInterval(timerInterval); 
            clearInterval(tokenkontrol); 
          },
        }).then((result) => {
          if (
            result.dismiss === Swal.DismissReason.timer
          ) {
            dispatch("logOut");
          }
          if (result.value) {
            clearInterval(timerInterval); 
            dispatch("ActionsRefreshToken");
          } else { 
            dispatch("logOut");
          }
        });
      }.bind(this),
      kalanzaman
    );
  },
 
};
